import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
//
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { CallApi } from "../../statics.js";
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  // const [fnameValue, setFnameValue] = useState("");
  // const [lnameValue, setLnameValue] = useState("");
  const [usernameValue, setusernameValue] = useState("");
  const [serverResponse, setServerResponse] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!getCookie("username") || !getCookie("token")) {
      navigate("/login");
    }

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
    };

    setServerResponse(false);
    CallApi("checkToken", "post", data)
      .then((result) => {
        try {
          if (result.status !== 200) {
            navigate("/login");
            return;
          }
          setusernameValue(getCookie("username"));
          setServerResponse(true);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        navigate("/login");
      });
  }, []);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  if (serverResponse) {
    return (
      <RootStyle>
        <DashboardNavbar
          onOpenSidebar={() => setOpen(true)}
          usernameValue={usernameValue}
        />
        <DashboardSidebar
          isOpenSidebar={open}
          onCloseSidebar={() => setOpen(false)}
        />
        <MainStyle style={{ zIndex: 2 }}>
          <Outlet />
        </MainStyle>
      </RootStyle>
    );
  } else {
    return (
      <CircularProgress
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        color="primary"
      />
    );
  }
}
